import PropTypes from 'prop-types';
export default {
  code: PropTypes.string.isRequired,
  units: PropTypes.string.isRequired
};